/* eslint-disable no-eval */
function loadAsync(url: string, callback: () => void) {
  const s = document.createElement('script');
  s.setAttribute('src', url);
  s.onload = callback;
  document.head.insertBefore(s, document.head.firstElementChild);
}

const customPaymentSuccess = (func: string) => {
  const customCode = `return actions.order.capture().then(function(orderData) {
  `;
  const templateCode = `return actions.order.capture().then(function(orderData) {`;
  return func.replace(templateCode, customCode);
};

export const loadScriptPaypal = (type, html: string) => {
  const regex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
  const scripts = html.match(regex);
  let pureHtml = html;
  switch (type) {
    case 'paypal':
      if (scripts && scripts.length === 2) {
        const srcFirst = scripts[0].match(/src="(.*?)"/);
        const src = srcFirst?.length && srcFirst.length > 1 ? srcFirst[1] : '';
        let func = scripts[1].replace(/<\/script>|<script>/g, '');
        func = customPaymentSuccess(func);
        scripts.forEach(script => {
          pureHtml = pureHtml.replace(script, '');
        });
        process.nextTick(() => {
          loadAsync(src, () => {
            eval(func);
          });
        });
      }
      break;
    case 'shopify':
      break;
    case 'link':
      break;
    default:
      break;
  }
  return pureHtml;
};
